module.exports = __webpack_public_path__ + "assets/img/teamYj.413d6355.svg";